import * as config from '@/config.json'

import Loading from 'vue-loading-overlay'
import axios from 'axios'
import PaginationNav from '../../../components/PaginationNav.vue'
import PaginationMobile from '../../../components/PaginationMobile.vue'
import moment from 'moment'
import LoadingComp from '../../../components/LoadingComp.vue'
import TableSkeleton from '../../../components/TableSkeleton.vue'
import * as functions from '../../../functions/functions'

export default {
  name: 'OrderItems',
  components: {
    Loading,
    PaginationNav,
    PaginationMobile,
    LoadingComp,
    TableSkeleton
  },
  data: () => {
    return {
      pagination: {},
      paginationRange: 6,
      currentPage: 1,
      perPage: 9,
      filter: '',
      token: null,
      itemsDetails: [],
      fieldsDetails: [],
      items: [],
      isMobile: false,
      windowWidth: 0,
      fields: [],
      selectedOption: 2,
      options: [
        {
          value: null,
          text: 'Sem Intervalo de Datas'
        },
        {
          value: 1,
          text: 'Ontem'
        },
        {
          value: 2,
          text: 'Hoje'
        },
        {
          value: 3,
          text: 'Últimos 7 dias'
        },
        {
          value: 4,
          text: 'Últimos 15 dias'
        },
        {
          value: 5,
          text: 'Últimos 30 dias'
        },
        {
          value: 6,
          text: 'Com Intervalo de Datas'
        }
      ],
      selectedFilterOption: null,
      filterOptions: [
        {
          value: null,
          text: '--- Selecione ---'
        },
        {
          value: 1,
          text: 'Barras'
        },
        {
          value: 2,
          text: 'Descrição'
        },
        {
          value: 3,
          text: 'Nome Cliente'
        },
        {
          value: 4,
          text: 'Documento Cliente'
        }
      ],
      isLoading: false,
      selectedOptionCompany: null,
      optionsCompany: [],
      selectedOptionSite: null,
      optionsSite: [],
      typeUser: null,
      qtdOrderItems: 0,
      pagePagination: null,

      startDate: moment(new Date()).format('YYYY-MM-DD'),
      endDate: moment(new Date()).format('YYYY-MM-DD'),
      totalRecords: 0,
      totalQuantity: 0,
      totalValue: 0,
      totalCost: 0,
      totalProfit: 0,

      isBusy: false,
      selectedCustomerFilter: null,
      optionsSelectCustomer: [
        {
          value: null,
          text: 'Todos'
        },
        {
          value: 1,
          text: 'Somente Identificado'
        },
        {
          value: 2,
          text: 'Somente Não Identificados'
        }
      ]
    }
  },
  methods: {
    /**
     * Constrói os campos da tabela dinamicamente baseado nos dados disponíveis
     * @param {Object} data - Dados da resposta da API
     * @returns {Array} Array de campos para a tabela
     */
    buildFieldsDynamic(data) {
      // Campos base que sempre estarão presentes
      const baseFields = [
        {
          key: 'name',
          label: 'Loja'
        },
        {
          key: 'sku',
          label: 'Barras'
        },
        {
          key: 'description',
          label: 'Descrição'
        },
        {
          key: 'totalCost',
          label: 'Custo Total'
        },
        {
          key: 'unitValue',
          label: 'Valor Unitário'
        },
        {
          key: 'totalQuantity',
          label: 'Qtde Itens'
        },
        {
          key: 'totalValue',
          label: 'Valor Total'
        },
        {
          key: 'profit',
          label: 'Lucro'
        },
        {
          key: 'markup',
          label: 'Markup'
        },
        {
          key: 'markdown',
          label: 'Markdown'
        }
      ]

      // Verificar se há dados de cliente nos itens de forma mais robusta
      let hasCustomerData = false

      // Lógica para determinar se os campos de cliente devem ser exibidos:
      // 1. Se o filtro estiver ativo para clientes (1=Identificados, 2=Não Identificados), sempre incluir
      // 2. Se não houver filtro ativo, verificar se há dados de cliente nos itens

      if (this.selectedCustomerFilter === 1 || this.selectedCustomerFilter === 2) {
        hasCustomerData = true
      } else {
        // Verificar se pelo menos um item tem dados de cliente
        hasCustomerData = data.items.some(item => item.customerName || item.customerDocument || item.customer || item.customerId)
      }

      // Campos de cliente que podem ou não estar presentes
      const customerFields = hasCustomerData
        ? [
            {
              key: 'customerName',
              label: 'Nome Cliente'
            },
            {
              key: 'customerDocument',
              label: 'Documento Cliente'
            }
          ]
        : []

      // Retornar todos os campos apropriados
      return [...baseFields, ...customerFields]
    },

    // Método para inicializar campos padrão (sem dados de cliente)
    initializeDefaultFields() {
      this.fields = [
        {
          key: 'name',
          label: 'Loja'
        },
        {
          key: 'sku',
          label: 'Barras'
        },
        {
          key: 'description',
          label: 'Descrição'
        },
        {
          key: 'totalCost',
          label: 'Custo Total'
        },
        {
          key: 'unitValue',
          label: 'Valor Unitário'
        },
        {
          key: 'totalQuantity',
          label: 'Qtde Itens'
        },
        {
          key: 'totalValue',
          label: 'Valor Total'
        },
        {
          key: 'profit',
          label: 'Lucro'
        },
        {
          key: 'markup',
          label: 'Markup'
        },
        {
          key: 'markdown',
          label: 'Markdown'
        }
      ]
    },

    // Método para forçar a reconstrução dos campos
    refreshFields() {
      if (this.items && this.items.length > 0) {
        this.fields = this.buildFieldsDynamic({ items: this.items })
      } else {
        this.initializeDefaultFields()
      }
    },

    // Método para verificar e ajustar o filtro de cliente automaticamente
    checkAndAdjustCustomerFilter() {
      // Só verifica quando os filtros de cliente estão selecionados
      if (this.selectedFilterOption === 3 || this.selectedFilterOption === 4) {
        if (this.items && this.items.length > 0) {
          const hasIdentified = this.items.some(item => item.customerName && item.customerName !== 'Consumidor' && item.customerDocument)

          console.log('Verificando clientes identificados para filtro de cliente:', {
            selectedFilterOption: this.selectedFilterOption,
            totalItems: this.items.length,
            hasIdentified,
            currentCustomerFilter: this.selectedCustomerFilter,
            sampleItems: this.items.slice(0, 3).map(item => ({
              customerName: item.customerName,
              customerDocument: item.customerDocument
            }))
          })

          if (!hasIdentified && this.selectedCustomerFilter !== 2) {
            console.log('Mudando filtro para "Somente Não Identificados"')
            this.selectedCustomerFilter = 2
            // Recarregar os dados com o novo filtro
            this.getOrderItems(this.currentPage)
          }
        }
      }
    },

    checkMobile() {
      this.windowWidth = window.innerWidth
      this.isMobile = this.windowWidth <= 800

      // Debug: verificar se os elementos mobile estão sendo exibidos
      if (this.isMobile) {
        const mobileElement = document.getElementById('mobile')
        const webElement = document.getElementById('web')

        // Forçar a exibição mobile se necessário
        if (mobileElement && webElement) {
          mobileElement.style.display = 'block'
          webElement.style.display = 'none'
        }
      }
    },

    forceMobileCheck() {
      // Método para forçar a verificação mobile
      setTimeout(() => {
        this.checkMobile()
      }, 100)
    },

    redirect(ref) {
      if (ref == 'Home') {
        this.$router.push(`/home`)
      }
    },

    async navigate(page) {
      await this.getOrderItems(page)
    },

    async getNotification(title, body, type) {
      this.$vToastify.setSettings({
        position: 'bottom-center'
      })
      await this.$vtNotify({
        title: title,
        body: body,
        type: type,
        duration: 3000
      })
    },

    async getCompanies() {
      const url = `${config.default.urlBase}/companies/user`

      try {
        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.optionsCompany = await Promise.all(
            response.data.map(item => {
              return {
                value: item.id,
                text: `${item.id} ${item.name}`
              }
            })
          )

          if (this.optionsCompany.length == 1) {
            this.selectedOptionCompany = this.optionsCompany[0].value
            this.getSitesByCompany(this.selectedOptionCompany)
          }
        }
      } catch (error) {
        console.error('Error in getCompanies:', error)

        this.optionsCompany = []
        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao buscar as empresas! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async getSitesByCompany(companyId) {
      const url = `${config.default.urlBase}/sites/company/${companyId}`

      this.selectedOptionSite = null

      try {
        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.sites = response.data

          this.optionsSite = await Promise.all(
            response.data.map(item => {
              return {
                value: item.id,
                text: `${item.id} ${item.name}`
              }
            })
          )

          if (this.optionsSite.length == 1) {
            this.selectedOptionSite = this.optionsSite[0].value
            await this.getOrderItems(this.currentPage)
          }

          if (this.optionsSite.length > 1 && this.typeUser != 'site') {
            await this.getOrderItems(this.currentPage)
          }
        }
      } catch (error) {
        console.error('Error in getSitesByCompany:', error)

        this.optionsSite = []
        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        }
        if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        }
      }
    },

    focus(id) {
      if (id === 'filter') {
        this.filter = ''
        // Focus no campo mobile se estiver em tela pequena
        if (window.innerWidth <= 800) {
          if (document.getElementById('filterMobile')) {
            document.getElementById('filterMobile').focus()
            return
          }
        }
      }
      if (document.getElementById(id)) {
        document.getElementById(id).focus()
      }
    },

    clearFilter() {
      this.filter = ''
      this.getOrderItems(this.currentPage)

      if (this.selectedFilterOption != null) {
        this.focus('filter')
      }
    },

    validateFilterInput(event) {
      const key = event.key

      // selectedFilterOption == 4 = Documento Cliente
      if (this.selectedFilterOption == 4) {
        // Bloquear letras e pontos - permitir apenas números
        if (!/^[0-9]$/.test(key) && !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(key)) {
          event.preventDefault()
          return false
        }
      }
      // selectedFilterOption == 1 = Barras (código de barras)
      else if (this.selectedFilterOption == 1) {
        // Bloquear apenas pontos - permitir números e letras
        if (key === '.') {
          event.preventDefault()
          return false
        }
      }

      return true
    },

    async clearSite() {
      this.selectedOptionSite = null
      await this.getOrderItems(this.currentPage)
    },

    async exportToXLSX(page) {
      this.isLoading = true

      const url = `${config.default.urlBase}/sites/order-items/export-to-xlsx`
      const paramsExport = this.buildParams(
        this.selectedOptionCompany,
        this.selectedOptionSite,
        this.selectedOption,
        this.startDate,
        this.endDate,
        this.selectedFilterOption,
        this.filter,
        this.selectedCustomerFilter,
        page,
        this.perPage,
        true
      )

      if (paramsExport != null) {
        try {
          const response = await axios({
            url,
            method: 'get',
            params: paramsExport,
            headers: {
              authorization: `Bearer ${this.token}`
            }
          })

          if (response.status == 200) {
            this.isLoading = false

            await functions.openFile(response.data.url)
          }
        } catch (error) {
          console.log({
            error
          })

          this.isLoading = false

          if (!error.response) {
            await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
          }

          if (error.response.status == 403) {
            await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
            this.$router.push('login')
          } else if (error.response.status == 404) {
            this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
          } else {
            await this.$alert(`Ocorreu um erro ao exportar o relatório! ${error.response.data.message}`, 'Aviso', 'warning')
          }
        }
      }
    },

    async getOrderItems(page) {
      this.isBusy = true

      const url = `${config.default.urlBase}/sites/order-items/search`
      const params = this.buildParams(
        this.selectedOptionCompany,
        this.selectedOptionSite,
        this.selectedOption,
        this.startDate,
        this.endDate,
        this.selectedFilterOption,
        this.filter,
        this.selectedCustomerFilter,
        page,
        this.perPage,
        false
      )

      console.log({ params })

      if (params != null) {
        try {
          const response = await axios({
            url,
            method: 'get',
            params,
            headers: {
              authorization: `Bearer ${this.token}`
            }
          })

          if (response.status == 200) {
            this.isBusy = false

            this.pagination = response.data
            this.pagination.rowsPerPage = this.perPage
            this.pagination.paginationRange = this.paginationRange

            this.items = response.data.items
            this.totalCost = response.data.totalCost
            this.totalQuantity = response.data.totalQuantity
            this.totalValue = response.data.totalValue
            this.totalProfit = response.data.totalProfit

            this.qtdOrderItems = response.data.records

            // Construir campos dinamicamente baseado nos dados recebidos
            this.fields = this.buildFieldsDynamic(response.data)
          }
        } catch (error) {
          console.error('Error in getOrderItems:', error)

          this.isBusy = false

          this.items = []
          this.pagination = []
          this.qtdOrderItems = 0

          this.totalCost = 0
          this.totalQuantity = 0
          this.totalValue = 0
          this.totalProfit = 0

          if (!error.response) {
            await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
          }

          if (error.response.status == 403) {
            await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
            this.$router.push('login')
          } else if (error.response.status != 404) {
            await this.$alert(`Ocorreu um erro ao buscar os itens das vendas! ${error.response.data.message}`, 'Aviso', 'warning')
          }
        }
      }
    },

    buildParams(
      companyId,
      siteId,
      selectedOption,
      startDate,
      endDate,
      selectedFilterOption,
      filter,
      selectedCustomerFilter,
      page,
      pageSize,
      exportToXLSX
    ) {
      if (this.selectedOptionCompany != null || this.selectedOptionSite != null) {
        let params = new Object()

        if (companyId != null) {
          params.companyId = companyId
        }

        if (siteId != null) {
          params.siteId = siteId
        }

        if (selectedOption == 1) {
          params.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD 00:00:00')
          params.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD 23:59:59')
        }

        if (selectedOption == 2) {
          params.startDate = moment().format('YYYY-MM-DD 00:00:00')
          params.endDate = moment().format('YYYY-MM-DD 23:59:59')
        }

        if (selectedOption == 3) {
          params.startDate = moment().subtract(6, 'days').format('YYYY-MM-DD 00:00:00')
          params.endDate = moment().format('YYYY-MM-DD 23:59:59')
        }

        if (selectedOption == 4) {
          params.startDate = moment().subtract(14, 'days').format('YYYY-MM-DD 00:00:00')
          params.endDate = moment().format('YYYY-MM-DD 23:59:59')
        }

        if (selectedOption == 5) {
          params.startDate = moment().subtract(29, 'days').format('YYYY-MM-DD 00:00:00')
          params.endDate = moment().format('YYYY-MM-DD 23:59:59')
        }

        if (selectedOption == 6) {
          if (startDate != null && endDate != null) {
            params.startDate = moment(startDate).format('YYYY-MM-DD 00:00:00')
            params.endDate = moment(endDate).format('YYYY-MM-DD 23:59:59')
          }
        }

        if (selectedFilterOption == 1 && filter != '') {
          params.sku = filter
        }

        if (selectedFilterOption == 2 && filter != '') {
          params.description = filter
        }

        if (selectedFilterOption == 3 && filter != '') {
          params.customerName = filter
        }

        if (selectedFilterOption == 4 && filter != '') {
          params.customerDocument = filter
        }

        if (selectedCustomerFilter == 1) {
          params.isCustomerIdentified = true
        }
        if (selectedCustomerFilter == 2) {
          params.isCustomerIdentified = false
        }

        if (exportToXLSX) {
          params.exportToXLSX = exportToXLSX
        } else {
          params.pageSize = pageSize
          params.page = page
        }

        return params
      } else {
        return null
      }
    }
  },

  computed: {
    showOrderItemsEmptyMessage() {
      return !this.isBusy && this.selectedOptionCompany && this.items.length === 0
    }
  },

  watch: {
    // Watcher para atualizar campos quando o filtro de cliente mudar
    selectedCustomerFilter: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          // Aguardar um pouco para que os dados sejam atualizados
          this.$nextTick(() => {
            this.refreshFields()
          })
        }
      },
      immediate: false
    },

    // Watcher para verificar quando o usuário seleciona filtros de cliente
    selectedFilterOption: {
      handler(newVal) {
        if (newVal === 3 || newVal === 4) {
          // Quando seleciona "Nome Cliente" ou "Documento Cliente", verificar se há clientes identificados
          this.$nextTick(() => {
            this.checkAndAdjustCustomerFilter()
          })
        }
      },
      immediate: false
    }
  },

  async beforeMount() {
    this.isLoading = true
    this.token = sessionStorage.getItem('token')
    this.typeUser = sessionStorage.getItem('typeUser')

    // Verificar se é mobile na inicialização
    this.checkMobile()

    // Inicializar campos padrão
    this.initializeDefaultFields()

    await this.getCompanies()

    this.isLoading = false
  },

  mounted() {
    // Adicionar listener para redimensionamento
    window.addEventListener('resize', this.checkMobile)

    // Forçar verificação mobile após a montagem
    this.forceMobileCheck()
  },

  beforeDestroy() {
    // Remover listener ao destruir o componente
    window.removeEventListener('resize', this.checkMobile)
  }
}
